<template>
  <div>
    <sub-menu-body @clickCard="carregarConsulta($event)" :titulo="titulo" :rotas="menu" :orientacoes="orientacoes"></sub-menu-body>
  </div>
</template>

<script>
import SubMenuBody from "@/components/SubMenuBody.vue";
import { mapMutations } from "vuex";
export default {
  name: "ConsultaMulta",
  components: { SubMenuBody },
  data() {
    return {
      titulo: "MULTA DE TRÂNSITO emitida pela Prefeitura de Belo Horizonte",
      menu: [],
      orientacoes: [],
    };
  },
   mounted() {
    this.carregarMenu();
    this.carregarOrientacoes();
  },
  methods: {
    ...mapMutations(["setFiltroPesquisa","setResultadoPesquisa"]),

    carregarConsulta(rota){
      this.setFiltroPesquisa({});
      this.setResultadoPesquisa({});
      this.$router.push({name: rota})
    },
    carregarMenu() {
      this.menu = this.$router.options.routes.filter((item) => item.componentRoot == "ConsultaMultaView");
    },

    carregarOrientacoes() {
      this.orientacoes = [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sodales neque sodales ut etiam sit. Porttitor rhoncus dolor purus non. ",
        "Euismod nisi porta lorem mollis. Ac tortor vitae purus faucibus ornare suspendisse sed. Imperdiet massa tincidunt nunc pulvinar sapien et ligula ullamcorper. Vitae tortor condimentum lacinia quis vel eros. Iaculis urna id volutpat lacus laoreet non. Ac ut consequat semper viverra nam libero justo laoreet sit. Egestas diam in arcu cursus euismod quis",
        "Non tellus orci ac auctor augue mauris. Tellus cras adipiscing enim eu turpis egestas. Nisl rhoncus mattis rhoncus urna neque viverra justo nec. Vel facilisis volutpat est velit egestas dui id ornare arcu. Sed viverra ipsum nunc aliquet bibendum enim facilisis gravida neque. Risus at ultrices mi tempus imperdiet nulla malesuada pellentesque",
      ];
    },
  },
};
</script>

<style>
</style>